import React, { useEffect } from "react";
import { IAcademicProfileDetail } from "../../../../../models/student/studentAcademicProfile";
import { setAcademicDetails } from "../../../../../store/slices/student/acradamicProfileSlice";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { ROUTER_URL } from "../../../../../constants/routerUrl";
import { Chart } from "primereact/chart";
import { getAcademicDetails } from "../../../../../action/student/academicProfileActionCreator";
import { getStudentInfoDetails } from "../../../../../action/student/studentInfoActionCreator";
import { connect } from "react-redux";

const BetaAcademicProfile = (props: IAcademicProfileDetail) => {
  const {
    getOverallAcademicDetails,
    academicDetails,
    userInfo,
    getStudentInfo,
    studentInfo,
  } = props;
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    if (userInfo && userInfo?.id) {
      getOverallAcademicDetails(userInfo?.id);
      getStudentInfo(userInfo?.id);
    }
  }, [userInfo?.id]);

  useEffect(() => {
    return () => {
      dispatch(setAcademicDetails([]));
    };
  }, []);

  const handleViewPage = () => {
    navigate(ROUTER_URL.STUDENT_ACADEMIC_PROFILE);
  };

  const data = {
    datasets: [
      {
        data: [
          academicDetails?.gradePointAverage,
          5 - academicDetails?.gradePointAverage,
        ], // Values for each segment
        backgroundColor: ["#0f8aad", "rgb(165, 164, 163)"],
        hoverOffset: 10, // Hover effect on segments
      },
    ],
  };
  const options = {
    cutout: "70%",
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: "left",
        labels: {
          usePointStyle: true,
          padding: 20,
        },
        display: false,
      },
      tooltip: {
        enabled: false,
      },
    },

    elements: {
      arc: {
        borderWidth: 4, // Controls the width of the border between segments
        borderColor: "white", // Optional: Adds a white border between segments
        borderRadius: 10, // Adjust this value for more or less rounded edges
      },
    },
    rotation: -90, // Rotates the chart to start from the top
    circumference: 180, // Draws only half of the chart
  };
  return (
    <>
      <div className="card h-100 student_metrics stud-course-chart">
        <a onClick={handleViewPage}>
          <div className="top">
            <div className="img">
              <img src="/assets/images/icon/chart-bar.svg" alt="" />
            </div>
            <div className="desc">
              <h2>Academic Profile</h2>
              <span>Details about your academic profile.</span>
            </div>
          </div>
          <div className="dtls">
            <ul className="desc">
              <li>
                <label>Academic Progress</label>
                <h6>
                  {academicDetails?.academicProgress &&
                    academicDetails?.academicProgress + "%"}
                </h6>
              </li>
              <li>
                <label>Completed Courses</label>
                <h6>{academicDetails?.completedCourses}</h6>
              </li>
              <li>
                <label>Total Credits</label>
                <h6>{academicDetails?.totalCourseCredits}</h6>
              </li>
            </ul>
            <div className="chartWrap-new">
              <p
                className="grade-point-title para-hide-2"
                style={{ fontWeight: "bold" }}
              >
                {studentInfo?.studentProgram?.programOfStudy}
              </p>
              <Chart
                type="doughnut"
                data={data}
                options={options}
                className=""
                width="300"
              />
              <div
                className="gauge-desc"
                
              >
                <h2>{academicDetails?.gradePointAverage}</h2>
                <h6>
                  <span>Grade Point Average</span>
                </h6>
              </div>
            </div>
          </div>
        </a>
      </div>
    </>
  );
};

const mapDispatchToProps = {
  getOverallAcademicDetails: (id: string) => getAcademicDetails(id),
  getStudentInfo: (id: string) => getStudentInfoDetails(id),
};

function mapStateToProps(state: any) {
  return {
    userInfo: state.userDetails.userProfileData,
    academicDetails: state.academicDetail.academicDetails,
    studentInfo: state.studentInfo.studentInfo,
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(BetaAcademicProfile);
